import React from 'react'
import MobileFileUploadComponent from '../../../../common/components/mobile-file-upload.component'
import { currency } from '../../../../common/services/common.service'

export default function ModalEwayComponent({ handleFileURlSubmit,
    selectedVehicleItem, dropLocations, pickupLocations, quoteDetails }: any) {

    return (


        <div className="w-full max-w-md p-4 bg-white mx-auto ">
            <h1 className="text-lg font-normal mb-4 text-center">Confirm Order</h1>

            {/* Top Section */}
            <div className=" p-4 border-b-2 border-gray-300">
                <div className='text-lg font-semibold mb-4'>Order Details</div>
                <div className="w-full grid grid-cols-1 gap-4">
                    <div className="pb-2">
                        <label className="text-sm font-semibold block">Vehicle Type</label>
                        <label className="text-sm block mt-1">{selectedVehicleItem?.VehicleType}</label>
                    </div>
                    <div className="pb-2">
                        <label className="text-sm font-semibold block">Total Distance</label>
                        <label className="text-sm block mt-1">{quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance} km</label>
                    </div>
                    <div className="pb-2">
                        <label className="text-sm font-semibold block">Amount Quoted</label>
                        <label className="text-sm block mt-1">{currency(quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value)}</label>
                    </div>
                    <div className="pb-2">
                        <label className="text-sm font-semibold block">Pickup Address</label>
                        <label className="text-sm block mt-1">{pickupLocations?.description}</label>
                    </div>
                    <div className="pb-2">
                        <label className="text-sm font-semibold block">Drop Address</label>
                        <label className="text-sm block mt-1">{dropLocations?.description}</label>
                    </div>
                </div>
            </div>
            <div className="p-4">
                {/* Upload E-way Bill */}
                <h2 className="text-lg font-semibold mb-4">E-way Bill Details</h2>
                <p className="text-base font-medium text-gray-800">Upload the E-way Bill</p>
                <div>
                    <MobileFileUploadComponent handleFileURlSubmit={handleFileURlSubmit} folder='shipping'
                        ownerId='0' />
                </div>
            </div>
        </div>



    )
}